import { render, staticRenderFns } from "./CloseX.vue?vue&type=template&id=97ec4eba&scoped=true"
import script from "./CloseX.vue?vue&type=script&lang=js"
export * from "./CloseX.vue?vue&type=script&lang=js"
import style0 from "./CloseX.vue?vue&type=style&index=0&id=97ec4eba&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97ec4eba",
  null
  
)

export default component.exports